/* klik-wg-gift.js · the Winter Gathering gift is chosen inside the purchase (owner, 5 Nov 2026: "For the free stuff make it
   through the purchase itself so customers don't need to contact. They can pick from limited options in the configurator").
   Loaded only inside the window (snippets/klik-winter-gathering part 'script', from klik-campaign 'config'); every entry
   point also checks klik-campaign.js's own clock (window.klikCampaign.wg()), so a page left open past the end goes quiet.
   One gift per order, two options in the sofa's fabric: a matching pouf (70 × 70 cm, 40 cm high) or a pair of matching
   scatter cushions (45 × 45 cm). The choice travels as the cart attribute "Winter gift" (Shopify order > Additional
   details), so the team reads it on the order. Never touches lines, prices, the add flow, DPO or tracking.
   1. Studio Review card: klik-studio-decide.js asks KlikWgGift.studio(ctx, total) on sofa set and corner sofa pages (the
      server prints [data-kwg-gift] only there): the two options at SAR 3,000 or more, else one line saying when it applies.
   2. After an add on those pages (klik:cart-added with a cart of SAR 3,000 or more): the choice is saved on the cart and
      shown in the "Added" sheet, where it can be changed.
   3. Cart page and drawer: the server block (klik-winter-gathering 'cart_gift', radios named attributes[Winter gift], so the
      checkout submit saves the choice even without this script): a change is saved at once, a qualifying cart without the
      attribute gets the shopper's choice, a cart that no longer qualifies loses it.
   Memory: sessionStorage 'klik-wg-gift' = pouf | cushions (the shopper's last pick); default pouf. */
(function () {
  'use strict';
  if (window.KlikWgGift) return;
  var doc = document, KEY = 'Winter gift', SS = 'klik-wg-gift', MIN = 300000;
  // the same two strings as klik-winter-gathering 'cart_gift' (the radios' values): the order shows them as they are
  var VAL = {
    pouf: 'Matching pouf 70×70 cm, 40 cm high, same fabric as the sofa · بوف بنفس قماش الكنبة 70×70 سم',
    cushions: '2 matching cushions 45×45 cm, same fabric as the sofa · زوج مخدات زينة بنفس قماش الكنبة 45×45 سم'
  };
  var ICON = {
    gift: 'M4 11.5h16V20H4zM3 7.5h18v4H3zM12 7.5V20M12 7.5C10.6 4.6 7 4.2 7 6.1c0 1.2 1.6 1.4 5 1.4Zm0 0c1.4-2.9 5-3.3 5-1.4 0 1.2-1.6 1.4-5 1.4Z',
    pouf: 'M5 9.5c0-1.1 3.1-2 7-2s7 .9 7 2v7c0 1.1-3.1 2-7 2s-7-.9-7-2zM5 9.5c0 1.1 3.1 2 7 2s7-.9 7-2',
    cushions: 'M4.5 6.2c2-.6 5-.6 7 0 .6 2 .6 5 0 7-2 .6-5 .6-7 0-.6-2-.6-5 0-7zM11.5 10.8c2-.6 5-.6 7 0 .6 2 .6 5 0 7-2 .6-5 .6-7 0-.6-2-.6-5 0-7z'
  };
  function on() { try { var c = window.klikCampaign; return !!(c && typeof c.wg === 'function' && c.wg() === 'on'); } catch (_) { return false; } }
  function ar() { return /^ar/i.test(doc.documentElement.lang || '') || /^ar\./.test(location.hostname); }
  function t(en, a) { return ar() ? a : en; }
  function kindOf(v) { v = String(v || ''); return /cushion|مخد/i.test(v) ? 'cushions' : (/pouf|بوف/i.test(v) ? 'pouf' : ''); }
  function picked() { try { var c = sessionStorage.getItem(SS); return c === 'pouf' || c === 'cushions' ? c : ''; } catch (_) { return ''; } }
  function remember(k) { try { sessionStorage.setItem(SS, k); } catch (_) {} }
  function sofaPage() { return !!doc.querySelector('[data-kwg-gift]'); }
  function root() { return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/'); }
  function el(tag, cls, text) { var n = doc.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function svg(k, cls) {
    var s = doc.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('aria-hidden', 'true'); s.setAttribute('focusable', 'false'); s.setAttribute('class', cls);
    var p = doc.createElementNS('http://www.w3.org/2000/svg', 'path');
    p.setAttribute('d', ICON[k]); p.setAttribute('fill', 'none'); p.setAttribute('stroke', 'currentColor');
    p.setAttribute('stroke-width', '1.5'); p.setAttribute('stroke-linejoin', 'round');
    s.appendChild(p);
    return s;
  }

  /* ---- saving: one request per value, never the same value twice in a row */
  var saved = null, flight = null, flightVal = null;
  function save(value) {
    if (saved === value) return Promise.resolve(true);
    if (flight && flightVal === value) return flight;
    var attrs = {};
    attrs[KEY] = value;
    flightVal = value;
    flight = fetch(root() + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { if (r.ok) saved = value; return r.ok; })
      .catch(function () { return false; })
      .then(function (ok) { flight = null; flightVal = null; return ok; });
    return flight;
  }
  function pick(k) { if (!VAL[k]) return; remember(k); save(VAL[k]); }

  /* ---- the two options (studio card and Added sheet; the cart block is the server's twin of this markup) */
  var seq = 0;
  function chooser(cur, title, note, onPick) {
    var name = 'kwg-pick-' + (++seq);
    var box = el('div', 'kwg-pick');
    box.setAttribute('role', 'radiogroup');
    box.setAttribute('aria-label', title);
    var h = el('p', 'kwg-pick__h');
    h.append(svg('gift', 'kwg-pick__gift'), el('span', null, title));
    var row = el('div', 'kwg-pick__opts');
    [['pouf', t('Matching pouf', 'بوف بنفس القماش'), t('70 × 70 cm', '70 × 70 سم')],
     ['cushions', t('2 matching cushions', 'زوج مخدات زينة'), t('45 × 45 cm', '45 × 45 سم')]].forEach(function (o) {
      var lab = el('label', 'kwg-pick__opt' + (cur === o[0] ? ' is-on' : ''));
      var inp = el('input');
      inp.type = 'radio'; inp.name = name; inp.value = o[0]; inp.checked = cur === o[0];
      inp.addEventListener('change', function () {
        if (!inp.checked) return;
        row.querySelectorAll('.kwg-pick__opt').forEach(function (l) { l.classList.toggle('is-on', l === lab); });
        onPick(o[0]);
      });
      var txt = el('span', 'kwg-pick__txt');
      txt.append(el('span', 'kwg-pick__t', o[1]), el('span', 'kwg-pick__s', o[2]));
      lab.append(inp, svg(o[0], 'kwg-pick__ico'), txt);
      row.appendChild(lab);
    });
    box.append(h, row);
    if (note) box.appendChild(el('p', 'kwg-pick__note', note));
    return box;
  }
  function hint(text) { var p = el('p', 'kwg-hint'); p.append(svg('gift', 'kwg-pick__gift'), el('span', null, text)); return p; }

  /* ---- 3. cart page and drawer: keep every server block and the cart attribute in step */
  function reflect(k) {
    doc.querySelectorAll('[data-kwg-cart="pick"] input[type="radio"]').forEach(function (i) {
      var m = kindOf(i.value) === k;
      i.checked = m;
      var l = i.closest('label');
      if (l) l.classList.toggle('is-on', m);
    });
  }
  function syncCart() {
    if (!on()) return;
    doc.querySelectorAll('[data-kwg-cart]').forEach(function (b) {
      var state = b.getAttribute('data-kwg-cart'), attr = b.getAttribute('data-kwg-attr') || '';
      if (state === 'pick') {
        var k = picked() || kindOf(attr) || 'pouf';
        reflect(k);
        if (attr === VAL[k]) saved = attr; else save(VAL[k]);
      } else if (attr) {
        save('');
      }
    });
  }
  doc.addEventListener('change', function (e) {
    var i = e.target;
    if (!i || !i.matches || !i.checked || !i.matches('[data-kwg-cart="pick"] input[type="radio"]')) return;
    var k = kindOf(i.value);
    if (!k) return;
    reflect(k);
    pick(k);
  });
  function watch() {
    doc.querySelectorAll('[data-kcv-slot="gift"]').forEach(function (slot) {
      if (slot.__kwgW) return;
      slot.__kwgW = true;
      try { new MutationObserver(function () { syncCart(); }).observe(slot, { childList: true }); } catch (_) {}
    });
  }

  /* ---- 1. studio Review card */
  function studio(ctx, total) {
    if (!on() || !sofaPage()) return null;
    var c = Math.round(Number(total) || 0);
    if (!(c > 0)) return null;
    if (c < MIN) return hint(t('Orders over SAR 3,000 get a free matching pouf or 2 cushions in the same fabric, until 10 Nov.', 'للطلبات فوق 3,000 ريال: بوف أو زوج مخدات زينة هدية بنفس القماش، حتى 10 نوفمبر.'));
    return chooser(picked() || 'pouf', t('Your free Winter Gathering gift', 'هديتك المجانية في لمّة الشتاء'),
      t("In your sofa's fabric, one per order. It is saved with your order when you add it to the cart.", 'بنفس قماش كنبتك، هدية واحدة لكل طلب، وتُحفظ مع طلبك عند إضافته إلى السلة.'),
      function (k) { remember(k); reflect(k); if (saved) save(VAL[k]); });
  }
  function sig(ctx, total) {
    if (!on() || !sofaPage()) return '';
    return (Math.round(Number(total) || 0) >= MIN ? 'g' : 'h') + (picked() || 'pouf');
  }

  /* ---- 2. after an add: save the choice and show it in the "Added" sheet */
  function sheetBlock(k) {
    var sheet = doc.querySelector('dialog.kcv-sheet[open]');
    if (!sheet) return;
    var anchor = sheet.querySelector('.kcv-sheet__vat') || sheet.querySelector('.kcv-sheet__paid');
    if (!anchor) return;
    var box = chooser(k, t('Your free Winter Gathering gift', 'هديتك المجانية في لمّة الشتاء'), t("In your sofa's fabric, saved with your order.", 'بنفس قماش كنبتك، وتُحفظ مع طلبك.'),
      function (x) { reflect(x); pick(x); });
    box.setAttribute('data-kwg-sheet', '');
    box.classList.add('kwg-pick--sheet');
    anchor.after(box);
  }
  doc.addEventListener('klik:cart-added', function (e) {
    try {
      var stale = doc.querySelector('[data-kwg-sheet]');
      if (stale) stale.remove();
      if (!on() || !sofaPage()) return;
      var d = (e && e.detail) || {}, cart = d.cart;
      if (!cart || !(Number(cart.total_price) >= MIN)) return;
      var attr = (cart.attributes && cart.attributes[KEY]) || '';
      var k = picked() || kindOf(attr) || 'pouf';
      if (attr === VAL[k]) saved = attr; else save(VAL[k]);
      reflect(k);
      sheetBlock(k);
    } catch (_) {}
  });

  var started = false;
  function init() {
    if (started) return;
    started = true;
    watch();
    syncCart();
    try { if (window.KlikStudioDecide && typeof window.KlikStudioDecide.refresh === 'function') window.KlikStudioDecide.refresh(); } catch (_) {}
  }
  // klik-campaign.js (the clock) runs after this deferred script: start once the document is parsed
  if (doc.readyState === 'complete') init();
  else { doc.addEventListener('DOMContentLoaded', init, { once: true }); setTimeout(init, 4000); }
  doc.addEventListener('cart:updated', function () { setTimeout(syncCart, 300); });

  window.KlikWgGift = Object.freeze({ version: '20261105a', studio: studio, sig: sig, on: on, choice: function () { return picked() || 'pouf'; }, values: VAL });
})();
